import ProviderAddOrUpdateContent from "../content/providerAddOrUpdateContent";
import Layout from "../layout/Layout";

const ProviderAddOrUpdate = () => {
  return (
    <Layout>
      <ProviderAddOrUpdateContent />
    </Layout>
  );
};

export default ProviderAddOrUpdate;
